
import React from "react";
import { Link } from "@/hooks/useLinks";
import { linkTypeIcons } from "./LinkTypeIcons";

interface LinkIconProps {
  link: Link;
}

export const LinkIcon = ({ link }: LinkIconProps) => {
  const Icon = linkTypeIcons[link.link_type];
  
  // Ensure URL has proper protocol
  const formatUrl = (url: string) => {
    if (!url) return '#';
    // If URL doesn't start with http:// or https://, add https://
    return url.match(/^https?:\/\//) ? url : `https://${url}`;
  };

  return (
    <a
      href={formatUrl(link.link_url)}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center p-3 text-brand-secondary hover:text-brand-primary transition-colors"
      title={link.link_label || link.link_type}
    >
      <Icon className="h-6 w-6" />
    </a>
  );
};
